import { useMentionableUsers } from 'features/richText/hooks/useMentionableUsers'
import React from 'react'

import { MentionPluginBase } from './MentionPluginBase'

export interface MentionPluginProps {
  maxSuggestions?: number
}

export const MentionPlugin: React.FC<MentionPluginProps> = ({
  maxSuggestions = 10,
}) => {
  const { data: users = [], isLoading } = useMentionableUsers()
  return (
    <MentionPluginBase
      users={users}
      isLoading={isLoading}
      maxSuggestions={maxSuggestions}
    />
  )
}
